const { VUE_APP_GAME_EMBED_HS: GAME_EMBED_HS } = process.env;

export { GAME_EMBED_HS };
